import { css, styled } from "styled-components";
import ChatModels from "../models/chat-models/ChatModels";
import ModelsSettings from "../models/models-settings/ModelsSettings";
import React, { useState } from "react";
import { Popover, Skeleton, Tooltip, Typography } from "antd";
import {
  DeleteModal,
  IPageableResponse,
  IConversation,
  UpdateConversation,
  deleteConversation,
  openNotification,
} from "@dataone/lib";
import { UseQueryResult, useMutation } from "@tanstack/react-query";
import { Loading } from "../Loading";
import { EditIcon, PlusIcon, TrashIcon, ExpandIcon } from "@dataone/icons";
import { ChatHistoryIcon } from "@dataone/icons";
interface DiscussionHistoryProps {
  onNewDiscussionClick: () => void;
  handleGetFromHistory: (conversation: IConversation, beforeDate: Date) => void;
  discussionHistories: IPageableResponse<IConversation> | undefined;
  isLoading: boolean;
  onDeleteSuccess: () => void;
  // refetchHistory: (options?: {
  //   throwOnError: boolean;
  //   cancelRefetch: boolean;
  // }) => Promise<UseQueryResult>;
  setIsCollapsed: (value: boolean) => void;
  isCollapsed: boolean;
  setNewDiscussionStarted: (value: boolean) => void;
  selectedConversation: IConversation | undefined;
  reachTheEndRefOfConversations?: React.MutableRefObject<HTMLElement | null>;
  conversationsRef?: React.MutableRefObject<HTMLDivElement | null>;
  topConversationsRef?: React.MutableRefObject<HTMLElement | null>;
  isLoadingMoreConversations?: boolean;
  handleRefetch?: (pageNo: number, itemAdded?: boolean) => void;
  setBeforeDate: React.Dispatch<React.SetStateAction<Date>>;
}
const DiscussionHistory = ({
  onNewDiscussionClick,
  handleGetFromHistory,
  discussionHistories,
  isLoading,
  onDeleteSuccess,
  // refetchHistory,
  setIsCollapsed,
  isCollapsed,
  setNewDiscussionStarted,
  selectedConversation,
  reachTheEndRefOfConversations,
  conversationsRef,
  topConversationsRef,
  isLoadingMoreConversations,
  handleRefetch,
  setBeforeDate,
}: DiscussionHistoryProps) => {
  const [showModelsSettings, setShowModelsSettings] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [title, setTitle] = useState("");
  const { mutate: removeConversation } = useMutation(deleteConversation);
  const { mutate: editConversation } = useMutation(UpdateConversation);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [conversationToDelete, setConversationToDelete] =
    useState<IConversation | null>(null);

  // const abortController = new AbortController();

  const handleDeleteConversation = (
    conversation: IConversation,
    event: React.MouseEvent<HTMLDivElement>
  ) => {
    event.stopPropagation();
    setConversationToDelete(conversation);
    // setSelectedIndex(index);
  };

  const handleCancelDelete = () => {
    setConversationToDelete(null);
    setDeleteLoading(false);
  };

  const handleConfirmDelete = () => {
    setDeleteLoading(true);
    conversationToDelete &&
      removeConversation([conversationToDelete.id || ""], {
        onSuccess: ({ message }) => {
          openNotification(message);
          setConversationToDelete(null);
          onDeleteSuccess();
          handleRefetch?.(0, true);
          if (
            selectedConversation?.id === conversationToDelete?.id ||
            !selectedConversation
          ) {
            onNewDiscussionClick();
          } else {
            setSelectedIndex(-1);
          }
          setDeleteLoading(false);
        },
      });
  };

  const handleEditClick = (
    index: number,
    event: React.MouseEvent<HTMLDivElement>
  ) => {
    event.stopPropagation();
    setIsEditing(true);
    setSelectedIndex(index);
  };

  const handleChange = (value: string) => {
    setTitle(value);
    setIsEditing(false);
    setSelectedIndex(-1);
    if (discussionHistories?.content[selectedIndex]?.label !== value) {
      editConversation(
        {
          id: discussionHistories?.content[selectedIndex]?.id,
          label: value,
        },
        {
          onSuccess: ({ message }) => {
            openNotification(message);
            handleRefetch?.(0, true);
          },
        }
      );
    }
  };
  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  return (
    <StyledDiscussionHistory>
      <StyledBtn onClick={onNewDiscussionClick} $collapsed={isCollapsed}>
        <StyledPlusIcon>
          <PlusIcon />
        </StyledPlusIcon>
        <div className="btn-desc">New discussion</div>
      </StyledBtn>
      <StyledCollapseIcon onClick={handleCollapse} $collapsed={isCollapsed}>
        <ExpandIcon />
      </StyledCollapseIcon>
      <StyledContainer>
        <div className="history-content" ref={conversationsRef}>
          {isLoading ? (
            <HistoryLoading>
              <Skeleton.Input active block size="small" />
              <Skeleton.Input active block size="small" />
              <Skeleton.Input active block size="small" />
              <Skeleton.Input active block size="small" />
            </HistoryLoading>
          ) : (
            <>
              <span ref={topConversationsRef}></span>
              <div>
                {discussionHistories?.content?.map((discussions, index) => (
                  <StyledContent
                    onClick={() => {
                      const newDate = new Date();
                      setBeforeDate(newDate);
                      handleGetFromHistory(discussions, newDate);
                    }}
                    key={index}
                  >
                    <StyledChatIcon>
                      <ChatHistoryIcon />
                    </StyledChatIcon>

                    <div className="content">
                      <Typography.Text
                        editable={{
                          tooltip: false,
                          enterIcon: null,
                          editing: isEditing && selectedIndex === index,
                          triggerType: ["text"],
                          onChange: (value) => handleChange(value),
                        }}
                      >
                        {isEditing && selectedIndex === index ? (
                          discussions.label
                        ) : (
                          <Tooltip
                            placement="topLeft"
                            title={
                              <span style={{ fontSize: "12px" }}>
                                {discussions.label}
                              </span>
                            }
                          >
                            {discussions.label}
                          </Tooltip>
                        )}
                      </Typography.Text>
                    </div>
                    <div className="actions">
                      {/* <img
                        onClick={(event) => handleEditClick(index, event)}
                        src={"images/smart-search/chat/pencil-icon.svg"}
                        alt="pencil-icon"
                        width={15}
                      /> */}
                      <StyledIcon
                        onClick={(event) => handleEditClick(index, event)}
                      >
                        <EditIcon />
                      </StyledIcon>
                      <StyledIcon
                        onClick={(event) =>
                          handleDeleteConversation(discussions, event)
                        }
                      >
                        <TrashIcon />
                      </StyledIcon>
                    </div>
                  </StyledContent>
                ))}
              </div>
              <span ref={reachTheEndRefOfConversations}></span>
              {isLoadingMoreConversations && (
                <StyledConversationsLoading>
                  <Loading />
                </StyledConversationsLoading>
              )}
              <div
                style={{ width: "100%", display: "flex", height: "5px" }}
              ></div>
            </>
          )}
        </div>
        <FooterDiv $collapsed={isCollapsed}>
          <div className="models-select">
            <ChatModels />
          </div>
          {/* <div className="settings">
            <Popover
              content={<ModelsSettings />}
              trigger="click"
              open={showModelsSettings}
              placement="topRight"
              onOpenChange={handleOpenChange}
              className="popover"
            >
              <img
                src={"images/smart-search/chat/settings-icon.svg"}
                alt="settings-icon"
              />
            </Popover>
          </div> */}
        </FooterDiv>
      </StyledContainer>
      <DeleteModal
        header="Are you sure you want
        to delete this conversation ?"
        containerId="#smartsearch-modal"
        typeToDelete="conversation"
        isModalOpen={!!conversationToDelete}
        selectedTitle={conversationToDelete?.label}
        handleCancel={handleCancelDelete}
        handleConfirm={handleConfirmDelete}
        message="All content will be lost"
        deleteLoading={deleteLoading}
      />
    </StyledDiscussionHistory>
  );
};

export default DiscussionHistory;

const StyledContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 18px;
  margin: 10px;
  cursor: pointer;
  .content {
    color: #040726;
    font-size: 13px !important;
    font-weight: 400;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    img {
      width: 16px;
    }
    .ant-typography {
      line-height: 30.896px;
      margin-left: 20px;
      margin-bottom: 0px !important;
      margin-top: 0px !important;
      max-width: 93%;
      width: fit-content;
      max-height: 35px;
      padding-right: 10px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      position: relative;
      overflow: hidden;
      word-break: break-all;
      font-size: 13px;
      .ant-typography-edit {
        position: relative;
        right: 0;
        top: 0;
      }
    }
    .ant-typography-edit-content {
      width: 93%;
      margin-top: 14px;
      textarea {
        height: 20px !important;
        overflow: hidden;
        resize: none;
        white-space: nowrap;
      }
    }
  }
  .actions {
    margin-left: auto;
    min-width: 56px;
    img {
      margin-left: 10px;
    }
    display: none;
  }
  &:hover {
    border-radius: 8px;
    border-left: 3px solid #4974f6;
    background: #eff1fd;
    .actions {
      display: flex;
      margin-left: auto;
    }
  }
`;

const StyledContainer = styled.div`
  border-radius: 10px;
  background: #fff;
  margin: 20px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  height: 100%;
  // padding-right: 5px;

  .history-content {
    overflow-y: auto;
    position: relative;

    &::-webkit-scrollbar {
      width: 10px;
    }

    &::-webkit-scrollbar-track {
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #8b8b8b;
      border-radius: 7px;
    }

    &::-webkit-scrollbar-button {
      display: block;
      height: 16px;
      width: 16px;
      background-color: #fff;
      border: none;
    }

    &::-webkit-scrollbar-button:single-button:vertical:decrement {
      height: 12px;
      width: 16px;
      background-position: center 6px;
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='50,00 0,50 100,50'/></svg>");
    }
    &::-webkit-scrollbar-button:single-button:vertical:increment {
      height: 12px;
      width: 16px;
      background-position: center center;
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='0,0 100,0 50,50'/></svg>");
    }
  }
`;

const StyledBtn = styled.div<{ $collapsed: boolean }>`
  cursor: pointer;
  display: ${(props) => (props.$collapsed ? "none" : "flex")};
  flex-direction: row;
  align-items: center;
  border-radius: 25px;
  background: rgba(239, 241, 253, 0.8);
  margin: ${(props) =>
    props.$collapsed ? "5px 20px 5px 0px" : "5px 20px 5px 20px"};
  width: 149px;
  height: 32px;
  .btn-desc {
    color: #000;
    font-size: 13px;
    font-weight: 400;
  }
  &:hover {
    scale: 1.01;
    opacity: 0.8;
  }
`;

const StyledConversationsLoading = styled.span`
  bottom: 21px;
  position: relative;
  left: 0;
`;

const FooterDiv = styled.div<{ $collapsed: boolean }>`
  margin-top: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  .settings {
    position: relative;
    margin-left: auto;
    margin-right: 10px;
    cursor: pointer;
    img {
      position: absolute;
      right: -2px;
      top: -10px;
    }
  }
  .models-select {
  }
  ${(props) =>
    props.$collapsed &&
    css`
      display: none;
    `}
`;

const StyledDiscussionHistory = styled.div`
  // height: 71.5%;
  height: calc(100vh - 223px);
  position: relative;
`;

const HistoryLoading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 30px 20px;
`;

const StyledCollapseIcon = styled.div<{ $collapsed: boolean }>`
  position: absolute;
  top: 5px;
  left: 89%;
  cursor: pointer;
  color: #000;
  font-size: 25px;
  svg {
    width: 22px;
    display: flex;
  }
  transform: rotate(180deg);
  ${(props) =>
    props.$collapsed &&
    css`
      right: 9px;
      left: auto;
      transform: rotate(0deg);
    `}
`;

const StyledPlusIcon = styled.div`
  padding: 5px;
  padding-top: 8px;
  opacity: 0.7;
  width: 22px;
`;

const StyledIcon = styled.div`
  display: flex;
  margin-left: auto;
`;

const StyledChatIcon = styled.div`
  font-size: 15px;
  width: 15px;
  color: #4974f6;
  display: flex;
`;
